import { render, staticRenderFns } from "./BpsDevAPISwitcher.vue?vue&type=template&id=384a26f8&scoped=true&"
import script from "./BpsDevAPISwitcher.vue?vue&type=script&lang=ts&"
export * from "./BpsDevAPISwitcher.vue?vue&type=script&lang=ts&"
import style0 from "./BpsDevAPISwitcher.vue?vue&type=style&index=0&id=384a26f8&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "384a26f8",
  null
  
)

export default component.exports